<template>
  <BCard>
    <div class="mb-8">
      <h1 class="text-[#333333] text-[20px] font-semibold">
        Kelola Business Manager
      </h1>
    </div>
    <!-- Analytic Cards -->
    <div
      class="mb-6 border rounded-lg px-[1rem] py-[1.5rem] bg-[url('https://storage.googleapis.com/komerce/assets/bg-bm-analytic-gray.png')] bg-no-repeat bg-right bg-contain"
    >
      <!-- Estimasi Total Penggunaan Saldo Section -->
      <div class="mb-[2rem]">
        <div class="flex items-center gap-x-[.5rem] mb-[1rem]">
          <div class="bm-analytic-card-icon-container size-[24px] bg-[#EFEFEF]">
            <span class="k-moneys !text-[#828282]" />
          </div>
          <h2 class="text-[#626262] text-[14px]">
            Estimasi Total Penggunaan Saldo
          </h2>
          <span
            id="tooltip-estimasi-saldo-info"
            class="cursor-pointer"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="8"
                cy="8"
                r="7"
                stroke="#08A0F7"
                stroke-width="1.5"
              />
              <path
                d="M8 7.5V11.5"
                stroke="#08A0F7"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <circle
                cx="8"
                cy="5"
                r="1"
                fill="#08A0F7"
              />
            </svg>
          </span>
          <b-tooltip
            target="tooltip-estimasi-saldo-info"
            triggers="hover"
            placement="topRight"
            variant="primary"
            custom-class="long-text-tooltip"
          >
            Dihitung berdasarkan akumulasi Estimasi Penggunaan Saldo dari pembaruan terakhir pada setiap Business
            Manager
          </b-tooltip>
        </div>
        <p class="text-[#333333] text-[36px] font-semibold">
          {{ IDR(analyticSection.total_estimated_balance || 0) }}
        </p>
      </div>

      <!-- Metrics Grid -->
      <div class="grid grid-cols-3 gap-[1rem]">
        <div class="bm-analytic-card">
          <div class="bm-analytic-card-icon-container size-[24px] bg-[#DFF3FF]">
            <span class="k-profile-2user !text-[#08A0F7]" />
          </div>
          <h2 class="text-[#626262] text-[14px]">
            Total Akun Business Manager
          </h2>
          <p class="text-[#333333] text-[30px] font-semibold basis-full">
            {{ analyticSection.total_bm }}
          </p>
        </div>
        <div class="bm-analytic-card">
          <div class="bm-analytic-card-icon-container size-[24px] bg-[#FEF2CD]">
            <span class="k-profile-2user !text-[#FBBC05]" />
          </div>
          <h2 class="text-[#626262] text-[14px]">
            Total Akun Partner
          </h2>
          <p class="text-[#333333] text-[30px] font-semibold basis-full">
            {{ analyticSection.total_account_count }}
          </p>
        </div>
        <div class="bm-analytic-card">
          <div class="bm-analytic-card-icon-container size-[24px] bg-[#FFEDED]">
            <span class="k-people !text-[#E31A1A]" />
          </div>
          <h2 class="text-[#626262] text-[14px]">
            Kuota Terpakai dari Kapasitas
          </h2>
          <p class="text-[#333333] text-[30px] font-semibold basis-full">
            {{ analyticSection.total_usage_percentage }}%
          </p>
        </div>
      </div>
    </div>
    <!-- Table -->
    <div class="border rounded-lg p-[1rem]">
      <!-- Tools -->
      <div class="flex justify-end gap-[1rem] mb-[1rem]">
        <div
          class="flex items-center !w-[300px] rounded-[8px] gap-[5px] px-[8px]  border-[1px] border-[#E2E2E2] h-[40px]"
        >
          <span
            class="k-search-normal-1 font-bold align-middle"
            style="font-size: 20px"
          />
          <BFormInput
            v-model="filter.keyword"
            placeholder="Cari nama atau ID BM"
            class="border-0 grow"
            @input="onSearchAccounts"
          />
        </div>
        <BButton
          type="button"
          variant="primary"
          @click="() => handleOpenBusinessManagerModal()"
        >
          Tambah BM
        </BButton>
      </div>
      <!-- List -->
      <BusinessManagerTable
        id="bm-management-table"
        :items="items"
        :loading="loadingTable"
        @scroll="onScrollTable"
        @view-detail="({ id }) => $router.push({ name: 'komads-bm-management-detail', params: { id } })"
        @edit-account="(item) => handleOpenBusinessManagerModal(item)"
      />
    </div>

    <!-- Add/Edit Business Manager Modal -->
    <AddOrEditBusinessManagerModal
      id="add-or-edit-business-manager-modal"
      :item="selectedItem"
      @close="handleCloseBusinessManagerModal"
      @submit="handleOpenBusinessManagerConfirmModal"
    />

    <!-- Add/Edit Business Manager Confirm Modal -->
    <AddOrEditBusinessManagerConfirmModal
      id="add-or-edit-business-manager-confirm-modal"
      :item-id="selectedItem ? selectedItem.id : null"
      :form="businessManagerModalForm"
      @close="handleCloseBusinessManagerConfirmModal"
      @success="validateParams"
    />
  </BCard>
</template>

<script>
import { IDR } from '@/libs/currency'
import { newAxiosIns } from '@/libs/axios'
import { mapState } from 'vuex'
import BusinessManagerTable from './Table.vue'
import AddOrEditBusinessManagerModal from './AddOrEditBusinessManagerModal.vue'
import AddOrEditBusinessManagerConfirmModal from './AddOrEditBusinessManagerConfirmModal.vue'

export default {
  components: { BusinessManagerTable, AddOrEditBusinessManagerModal, AddOrEditBusinessManagerConfirmModal },
  data() {
    return {
      IDR,
      analyticSection: {},
      filter: {
        keyword: '',
      },
      limit: 10,
      offset: 0,
      isLastData: false,
      items: [],
      loadingTable: false,
      selectedItem: null,
      businessManagerModalForm: null,
    }
  },
  computed: {
    ...mapState('filterKomads', [
      'searchHistory',
    ]),
  },
  async mounted() {
    await this.validateParams()
  },
  beforeDestroy() {
    this.resetTable()
  },
  methods: {
    /**
     * Fetch business manager list with pagination and keyword filter.
     * Append result to items and update analytic section on first load.
     */
    async getBusinessManagerList() {
      this.loadingTable = true

      this.$store.dispatch('filterKomads/updateSearchHistory', this.filter.keyword)

      const params = {
        limit: this.limit,
        offset: this.offset,
        search: this.filter.keyword,
      }

      const url = 'komads/api/v1/admin/system_bm/summary'

      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const {
            data: {
              list,
              total_bm,
              total_account_count,
              total_usage_percentage,
              total_estimated_balance,
            },
          } = res.data

          if (this.items.length < 1) {
            this.analyticSection = {
              total_bm,
              total_account_count,
              total_usage_percentage,
              total_estimated_balance,
            }
          }

          if (list.length < this.limit) {
            this.isLastData = true
          } else {
            this.isLastData = false
          }

          this.items.push(...list)
          this.offset += list.length
        })
        .catch(() => {
          this.items = []
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    /**
     * Debounced search handler.
     * Reload data based on current keyword.
     */
    onSearchAccounts: _.debounce(async function search() {
      this.offset = 0
      this.isLastData = false
      this.items = []
      // Simpan nilai filter saat ini ke store
      this.$store.dispatch('filterKomads/updateSearchHistory', this.filter.keyword)
      await this.getBusinessManagerList()
    }, 1000),
    /**
     * Validate stored search params.
     * Restore previous search keyword or load default data.
     */
    validateParams() {
      if (this.searchHistory !== '') {
        this.filter.keyword = this.searchHistory
        this.onSearchAccounts()
        return
      }
      this.items = []
      this.offset = 0
      this.getBusinessManagerList()
    },
    /**
     * Handle infinite scroll event.
     * Load more data when reaching near bottom of table.
     */
    onScrollTable(event) {
      const table = event.target || document.querySelector('#bm-management-table')
      const isScrollEnd = table.scrollTop >= table.scrollHeight - table.offsetHeight - 20
      if (isScrollEnd && !this.isLastData && !this.loadingTable) this.getBusinessManagerList()
    },
    /**
     * Reset table state including  search keyword.
     */
    resetTable() {
      this.offset = 0
      this.filter.keyword = ''
      this.$store.dispatch('filterKomads/updateSearchHistory', this.filter.keyword)
      this.items = []
    },
    /**
     * Open add/edit business manager modal.
     * Set selected item if provided.
     */
    handleOpenBusinessManagerModal(item = null) {
      this.selectedItem = item ? { ...item, platform: item.platform || 'meta' } : null
      this.$bvModal.show('add-or-edit-business-manager-modal')
    },
    /**
     * Close add/edit business manager modal.
     */
    handleCloseBusinessManagerModal() {
      this.$bvModal.hide('add-or-edit-business-manager-modal')
    },
    /**
     * Open confirmation modal with submitted form data.
     * Close main modal before showing confirmation.
     */
    handleOpenBusinessManagerConfirmModal(form) {
      this.businessManagerModalForm = { ...form }
      this.handleCloseBusinessManagerModal()
      this.$bvModal.show('add-or-edit-business-manager-confirm-modal')
    },
    /**
     * Close confirmation modal and reset related states.
     */
    handleCloseBusinessManagerConfirmModal() {
      this.businessManagerModalForm = null
      this.selectedItem = null
      this.$bvModal.hide('add-or-edit-business-manager-confirm-modal')
    },
  },
}
</script>

<style scoped>
::v-deep .btn-primary {
  border-radius: 10px !important;
}

.bm-analytic-card {
  padding: 1.5rem 1rem;
  @apply border rounded-lg bg-white w-full flex flex-wrap items-center gap-x-2 gap-y-4;
}

.bm-analytic-card-icon-container {
  @apply rounded-md flex justify-center items-center;
}

h1,
h2,
p {
  @apply m-0;
}
</style>
